(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mb-faq"] && !Shopify.designMode) return;
  try {
    
function initMammaBumpFAQ(){
const root=document.getElementById('mb-faq');if(!root||root.dataset.ready)return;root.dataset.ready='true';
const search=root.querySelector('#mbfaq-faq-search');
const clear=root.querySelector('#mbfaq-clear-search');
const groups=[...root.querySelectorAll('.faq-group')];
const buttons=[...root.querySelectorAll('[data-category]')];
const items=[...root.querySelectorAll('details')];
const results=root.querySelector('#mbfaq-results-bar');
const status=root.querySelector('#mbfaq-result-count');
const empty=root.querySelector('#mbfaq-empty-results');
let selected='shipping';
const normalize=s=>s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,' ').trim();
const corpus=new Map(items.map(item=>[item,normalize(item.textContent+' '+item.dataset.keywords)]));
function browse(category){
 selected=category;search.value='';clear.hidden=true;results.hidden=true;empty.hidden=true;
 buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.category===category)));
 groups.forEach(g=>g.hidden=Boolean(category&&g.dataset.group!==category));
 items.forEach(item=>{item.hidden=false;item.open=false});
}
buttons.forEach(b=>b.addEventListener('click',()=>browse(b.dataset.category)));
search.addEventListener('input',()=>{
 const terms=normalize(search.value).split(' ').filter(Boolean);
 clear.hidden=!search.value;
 if(!terms.length){browse(selected);return;}
 results.hidden=false;buttons.forEach(b=>b.setAttribute('aria-pressed','false'));
 let count=0;
 items.forEach(item=>{const matches=terms.every(term=>corpus.get(item).includes(term));item.hidden=!matches;item.open=matches;if(matches)count++});
 groups.forEach(g=>g.hidden=![...g.querySelectorAll('details')].some(d=>!d.hidden));
 status.textContent=`${count} ${count===1?root.dataset.answer:root.dataset.answers} ${root.dataset.found}`;empty.hidden=count!==0;
});
clear.addEventListener('click',()=>{browse(selected);search.focus()});
root.querySelector('#mbfaq-show-all').addEventListener('click',()=>browse(null));

browse('shipping');root.querySelector('#mbfaq-shipping-0').open=true;
}
initMammaBumpFAQ();document.addEventListener('shopify:section:load',initMammaBumpFAQ);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-journal"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (scope = document) => {
    const roots = scope.matches?.('[data-mbj-section]') ? [scope] : scope.querySelectorAll('[data-mbj-section]');
    roots.forEach(root => {
      if (root.dataset.mbjReady) return;
      root.dataset.mbjReady = 'true';
      const find = s => root.querySelector(s);
      const grid = find('[data-mbj-grid]');
      const buttons = [...root.querySelectorAll('[data-topic]')];
      const input = find('[data-mbj-search]');
      const title = find('[data-mbj-grid-title]');
      const perPage = Number(root.dataset.pageSize) || 6;
      let limit = perPage, cards = [...grid.querySelectorAll('[data-mbj-card]')], busy = false, failed = false;
      const controller = new AbortController();
      root.mbjCleanup = () => controller.abort();
      const normalize = text => text.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
      let url = new URL(window.location.href);
      let active = url.searchParams.get('journal_topic') || '';
      if (!buttons.some(b => b.dataset.topic === active)) active = '';
      if (input) input.value = url.searchParams.get('journal_q') || '';
      const matchTopic = card => {
        if (!active) return true;
        const b = buttons.find(item => item.dataset.topic === active);
        if (!b) return true;
        if (card.dataset.category) return normalize(card.dataset.category) === normalize(b.dataset.label);
        const text = normalize(card.dataset.search || '');
        return (b.dataset.keywords || b.dataset.label).split(',').map(normalize).filter(Boolean).some(word => text.includes(word));
      };
      const updateURL = () => {
        const u = new URL(window.location.href);
        active ? u.searchParams.set('journal_topic',active) : u.searchParams.delete('journal_topic');
        input?.value.trim() ? u.searchParams.set('journal_q',input.value.trim()) : u.searchParams.delete('journal_q');
        window.history.replaceState(null,'',u);
      };
      const render = () => {
        const query = normalize(input?.value || '');
        const terms = query.split(/\s+/).filter(Boolean);
        const matched = cards.filter(card => matchTopic(card) && terms.every(term => normalize(card.dataset.search || '').includes(term)));
        const shown = new Set(matched.slice(0,limit));
        cards.forEach(card => card.hidden = !shown.has(card));
        buttons.forEach(b => b.setAttribute('aria-pressed',String(b.dataset.topic === active)));
        root.querySelectorAll('[data-mbj-editorial]').forEach(el => el.hidden = Boolean(active || query));
        title.textContent = query ? root.dataset.searchHeading : active ? buttons.find(b=>b.dataset.topic===active).dataset.label : title.dataset.original;
        find('[data-mbj-count]').textContent = busy ? root.dataset.loadingLabel : matched.length === 1 ? root.dataset.singularLabel : root.dataset.countLabel.replace('[count]',matched.length);
        find('[data-mbj-empty]').hidden = busy || matched.length > 0;
        find('[data-mbj-load-area]').hidden = matched.length <= limit;
        if (!busy && !failed) find('[data-mbj-status]').textContent = '';
        return matched;
      };
      const reset = () => {active='';if(input)input.value='';limit=perPage;updateURL();render()};
      find('[data-mbj-topics]').hidden = false;
      buttons.forEach(b => b.addEventListener('click',()=>{active=b.dataset.topic;limit=perPage;updateURL();render()}));
      input?.addEventListener('input',()=>{limit=perPage;updateURL();render()});
      find('[data-mbj-search-form]')?.addEventListener('submit',e=>{e.preventDefault();render();find('[data-mbj-grid-title]').scrollIntoView({block:'center',behavior:'instant'})});
      find('[data-mbj-reset]').addEventListener('click',reset);
      find('[data-mbj-more]').addEventListener('click',()=>{const prev=limit;limit+=perPage;const matched=render();matched[prev]?.querySelector('a')?.focus({preventScroll:true})});
      find('[data-mbj-pagination]')?.setAttribute('hidden','');
      root.addEventListener('shopify:block:select',e=>{active='';if(input)input.value='';limit=cards.length;render();e.target.scrollIntoView({block:'center',behavior:'instant'})});
      render();
      const loadArchive = async () => {
        let next = find('[data-mbj-next]')?.href;
        if (!next) return;
        busy = true;render();
        const seen = new Set(cards.map(c=>c.dataset.articleId)), pages = new Set();
        try {
          while(next) {
            const nextURL = new URL(next,window.location.href);
            const requestURL = new URL(window.location.href);
            nextURL.searchParams.forEach((v,k)=>requestURL.searchParams.set(k,v));
            requestURL.searchParams.set('section_id',root.dataset.mbjSection);
            requestURL.searchParams.delete('journal_q');requestURL.searchParams.delete('journal_topic');
            if(pages.has(requestURL.href)) throw new Error('Repeated archive page');
            pages.add(requestURL.href);
            const response = await fetch(requestURL,{signal:controller.signal,credentials:'same-origin'});
            if(!response.ok)throw new Error('Archive unavailable');
            const doc = new DOMParser().parseFromString(await response.text(),'text/html');
            const section = doc.querySelector('[data-mbj-section]');
            if(!section)throw new Error('Missing journal');
            section.querySelectorAll('[data-mbj-card]').forEach(card=>{if(!seen.has(card.dataset.articleId)){seen.add(card.dataset.articleId);grid.append(card);cards.push(card)}});
            next = section.querySelector('[data-mbj-next]')?.getAttribute('href');
          }
        } catch(error) {
          if(error.name==='AbortError')return;
          failed=true;find('[data-mbj-status]').textContent=root.dataset.errorLabel;
          find('[data-mbj-pagination]')?.removeAttribute('hidden');
        } finally {busy=false;if(root.isConnected)render()}
      };
      loadArchive();
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-mbj-section]').forEach(root=>root.mbjCleanup?.()));
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-luna-campaign"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mb-luna-story')) {
  customElements.define('mb-luna-story', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.ready = () => this.initialize();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.ready, {once:true,signal:this.controller.signal});
      else this.initialize();
    }
    initialize() {
      const signal = this.controller.signal;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.partsSection = this.querySelector('[data-parts-photo]');
      this.parts = JSON.parse(this.querySelector('[data-parts-content]').textContent);
      this.panel = this.querySelector('.parts-detail');
      this.addEventListener('click', event => {
        const button = event.target.closest('button,a');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-mode-select')) {
          this.querySelectorAll('[data-mode-select]').forEach(el => el.setAttribute('aria-pressed',String(el===button)));
          this.querySelectorAll('[data-mode-panel]').forEach(el => {el.hidden=el.dataset.modePanel!==button.dataset.modeSelect;});
        }
        if (button.hasAttribute('data-part-select')) this.selectPart(button.dataset.partSelect,button.classList.contains('parts-pin'));
        if (button.classList.contains('parts-return')) {
          this.selectPart('all',true);
          this.querySelector('[data-part-select="all"]').focus({preventScroll:true});
        }
        if (button.hasAttribute('data-shop-top')) {
          const product = document.querySelector('[id^="Product--"][data-section-type="product"]') || document.querySelector('[id^="Product--"]');
          const target = product?.querySelector('.form__wrapper') || product?.querySelector('.product__form') || product?.querySelector('[data-product-info]') || product;
          if (!target) return;
          event.preventDefault();
          const sticky = document.querySelector('[data-header-height]')?.getBoundingClientRect().height || parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 100;
          window.scrollTo({top:Math.max(0,target.getBoundingClientRect().top+window.scrollY-sticky-24),behavior:this.reduced.matches?'instant':'smooth'});
          const control = target.querySelector('select:not([disabled]),input:not([type="hidden"]):not([disabled]),button[data-add-to-cart]:not([disabled])');
          if (control) control.focus({preventScroll:true});
          else {target.setAttribute('tabindex','-1');target.focus({preventScroll:true});}
        }
      },{signal});
      if ('IntersectionObserver' in window && !this.reduced.matches) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {if(entry.isIntersecting){entry.target.classList.add('charging-is-visible');this.observer.unobserve(entry.target);}});
        },{threshold:.35});
        this.querySelectorAll('[data-charging-scene]').forEach(el => this.observer.observe(el));
      }
    }
    selectPart(key, scroll) {
      if (key!=='all' && !this.parts[key]) return;
      this.querySelectorAll('[data-part-select]').forEach(el => el.setAttribute('aria-pressed',String(el.dataset.partSelect===key)));
      if (key === 'all') {
        this.panel.hidden=true;
        this.panel.replaceChildren();
        if(scroll) this.partsSection.scrollIntoView({behavior:this.reduced.matches?'instant':'smooth',block:'start'});
        return;
      }
      const part=this.parts[key];
      const content=this.partsSection.querySelector('template').content.cloneNode(true);
      const art=content.querySelector('.parts-detail-art');
      const img=document.createElement('img');img.alt=part.alt;img.decoding='async';
      if(part.art){img.src=part.art;img.width=1254;img.height=1254;art.append(img);}
      else {
        const [x,y,w,h]=part.crop,crop=document.createElement('div');
        if(w/h>2)art.classList.add('is-wide');
        crop.className='parts-crop';crop.style.width=Math.min(94,90*w/h/1.12)+'%';
        crop.style.setProperty('--crop-ratio',w+'/'+h);crop.style.setProperty('--image-width',1448/w*100+'%');
        crop.style.setProperty('--image-left',-x/w*100+'%');crop.style.setProperty('--image-top',-y/h*100+'%');
        img.src=part.cropArt;img.width=1448;img.height=1086;crop.append(img);art.append(crop);
      }
      content.querySelector('.parts-detail-name').textContent=part.name;
      const title=content.querySelector('h3'),em=document.createElement('em');
      title.append(document.createTextNode(part.title[0]),document.createElement('br'));em.textContent=part.title[1];title.append(em);
      content.querySelector('.parts-detail-description').textContent=part.description;
      const sizes=content.querySelector('.parts-size-list');
      if(part.sizes)part.sizes.forEach(size=>{const li=document.createElement('li');li.textContent=size;sizes.append(li);});else sizes.remove();
      content.querySelector('.parts-care strong').textContent=part.careTitle;content.querySelector('.parts-care span').textContent=part.care;
      this.panel.replaceChildren(content);this.panel.hidden=false;
      if(scroll)this.querySelector('.parts-explorer').scrollIntoView({behavior:this.reduced.matches?'instant':'smooth',block:'start'});
    }
    disconnectedCallback() {
      this.controller?.abort();this.controller=null;this.observer?.disconnect();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-luna-difference"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new Map();
  function mount(root) {
    if (instances.has(root)) return;
    const track = root.querySelector('.mblc__track');
    const cards = Array.from(root.querySelectorAll('[data-mblc-card]'));
    const dots = Array.from(root.querySelectorAll('[data-mblc-dot]'));
    const previous = root.querySelector('[data-mblc-prev]');
    const next = root.querySelector('[data-mblc-next]');
    const count = root.querySelector('[data-mblc-count]');
    if (!track || !cards.length) return;
    const controller = new AbortController();
    const signal = controller.signal;
    let current = 0, frame = 0;
    const mobile = () => window.matchMedia('(max-width:760px)').matches;
    const position = index => cards[index].offsetLeft - cards[0].offsetLeft;
    function sync() {
      frame = 0;
      if (!mobile() || track.scrollWidth <= track.clientWidth + 1) current = 0;
      else {
        current = cards.reduce((best, card, index) => Math.abs(position(index) - track.scrollLeft) < Math.abs(position(best) - track.scrollLeft) ? index : best, 0);
        if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) current = cards.length - 1;
      }
      dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === current)));
      if (previous) previous.disabled = current === 0;
      if (next) next.disabled = current === cards.length - 1;
      if (count) count.textContent = `${current + 1} / ${cards.length}`;
    }
    function go(index, instant = false) {
      if (!mobile()) return;
      const target = Math.max(0, Math.min(cards.length - 1, index));
      const reduced = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
      track.scrollTo({ left: position(target), behavior: instant || reduced ? 'auto' : 'smooth' });
    }
    dots.forEach((dot, index) => dot.addEventListener('click', () => go(index), {signal}));
    previous?.addEventListener('click', () => go(current - 1), {signal});
    next?.addEventListener('click', () => go(current + 1), {signal});
    track.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(sync); }, {passive:true,signal});
    track.addEventListener('keydown', event => {
      if (event.target !== track || !mobile()) return;
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      go(event.key === 'Home' ? 0 : event.key === 'End' ? cards.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1));
    }, {signal});
    const observer = new ResizeObserver(sync);
    observer.observe(track);
    root.setAttribute('data-ready', '');
    sync();
    instances.set(root, { go, destroy() { controller.abort(); observer.disconnect(); cancelAnimationFrame(frame); root.removeAttribute('data-ready'); instances.delete(root); } });
  }
  function scan(container) { if (container.matches?.('[data-mblc]')) mount(container); container.querySelectorAll?.('[data-mblc]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), {once:true});
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => { for (const [root, instance] of instances) if (event.target === root || event.target.contains(root)) instance.destroy(); });
  document.addEventListener('shopify:block:select', event => {
    const card = event.target.closest?.('[data-mblc-card]');
    const root = card?.closest('[data-mblc]');
    if (!root) return;
    const index = Array.from(root.querySelectorAll('[data-mblc-card]')).indexOf(card);
    instances.get(root)?.go(index, true);
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-mb-community-results"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('input', function(event) {
  const range = event.target;
  if (!(range instanceof HTMLInputElement) || !range.matches('.mb-results__range')) return;
  const comparison = range.closest('.mb-results__comparison');
  if (!comparison) return;
  comparison.style.setProperty('--split', range.value + '%');
  range.setAttribute('aria-valuetext', range.dataset.valueLabel.replace('[value]', range.value));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-video-steps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mb-video-steps')) {
    customElements.define('mb-video-steps', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.mobile = window.matchMedia('(max-width: 724px)');
        this.swiperElement = this.querySelector('.swiper');
        this.changeLayout = () => {
          if (this.mobile.matches && this.near) this.initSwiper();
          if (!this.mobile.matches) {
            this.querySelectorAll('.video-step-videos-m mb-deferred-video').forEach(video => {
              video.setAttribute('data-active', 'false');
            });
          } else {
            this.selectSlide(this.swiper?.activeIndex || 0);
          }
        };
        this.mobile.addEventListener('change', this.changeLayout, options);
        this.querySelectorAll('.video-container .video-item').forEach(item => {
          item.addEventListener('pointerenter', () => {
            this.querySelectorAll('.video-container .video-item').forEach(other => {
              const active = other === item;
              other.classList.toggle('active', active);
              other.classList.toggle('inactive', !active);
              other.style.flex = active ? '2 1 0' : '1 1 0';
              other.querySelector('mb-deferred-video')?.setAttribute('data-active', String(active));
            });
          }, options);
          item.addEventListener('pointerleave', () => {
            this.querySelectorAll('.video-container .video-item').forEach(other => {
              other.style.flex = '1 1 0';
              other.classList.remove('active', 'inactive');
              other.querySelector('mb-deferred-video')?.setAttribute('data-active', 'false');
            });
          }, options);
        });
        this.querySelectorAll('.swiper-button-next, .swiper-button-prev').forEach(button => {
          button.addEventListener('click', () => {
            if (this.swiper || !this.swiperElement) return;
            const width = this.swiperElement.querySelector('.swiper-slide')?.offsetWidth || 0;
            this.swiperElement.scrollBy({ left: (width + 2) * (button.classList.contains('swiper-button-next') ? 1 : -1), behavior: 'smooth' });
          }, options);
        });
        this.swiperElement?.addEventListener('scroll', () => {
          if (this.swiper) return;
          const width = this.swiperElement.querySelector('.swiper-slide')?.offsetWidth || 1;
          this.selectSlide(Math.round(this.swiperElement.scrollLeft / width));
        }, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.near = entries[0].isIntersecting;
            this.changeLayout();
          }, { rootMargin: '400px 0px' });
          this.observer.observe(this);
        } else {
          this.near = true;
          this.changeLayout();
        }
      }

      selectSlide(index) {
        this.querySelectorAll('.swiper-slide mb-deferred-video').forEach((video, i) => {
          video.setAttribute('data-active', String(this.mobile.matches && i === index));
        });
      }

      async initSwiper() {
        if (this.swiper || this.initializing || !this.swiperElement) return;
        this.initializing = true;
        try {
          if (!window.Swiper) {
            if (!window.mammaBumpSwiperReady) {
              window.mammaBumpSwiperReady = new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = this.dataset.swiperSrc;
                script.async = true;
                script.onload = resolve;
                script.onerror = () => {
                  script.remove();
                  window.mammaBumpSwiperReady = null;
                  reject(new Error('Video carousel could not load'));
                };
                document.head.appendChild(script);
              });
            }
            await window.mammaBumpSwiperReady;
          }
          if (!this.isConnected || !this.mobile.matches || !this.near || !window.Swiper) return;
          this.swiper = new window.Swiper(this.swiperElement, {
            slidesPerView: 'auto', spaceBetween: 2, centeredSlides: false,
            breakpoints: { 0: { slidesPerView: 1.15 }, 421: { slidesPerView: 2.15 } },
            navigation: {
              nextEl: this.querySelector('.swiper-button-next'),
              prevEl: this.querySelector('.swiper-button-prev')
            },
            on: {
              slideChange: swiper => this.selectSlide(swiper.activeIndex),
              afterInit: swiper => this.selectSlide(swiper.activeIndex)
            }
          });
        } catch {
          this.querySelectorAll('.swiper-slide video').forEach(video => { video.controls = true; });
        } finally {
          this.initializing = false;
        }
      }

      disconnectedCallback() {
        this.events?.abort();
        this.events = null;
        this.observer?.disconnect();
        this.swiper?.destroy(true, true);
        this.swiper = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
